export const dataToUpperCase = (values: any) => {
  return Object.keys(values).forEach(item => {
    if (item.includes("Name") || item.includes("pid")) {
      values[item] = values[item].toUpperCase();
    }
  });
};
